import React, { useState, useCallback } from 'react';
import { Button } from './@/components/ui/button';
import { Input } from './@/components/ui/input';
import { Label } from './@/components/ui/label';
import './Login.css';
import bcrypt from 'bcryptjs'; // You'll need to install this package

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  const partnerCredentials = {
    [process.env.REACT_APP_PARTNER1_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER1_HASHED_PASSWORD_ENCODED),
    },
    [process.env.REACT_APP_PARTNER2_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER2_HASHED_PASSWORD_ENCODED),
    },
    [process.env.REACT_APP_PARTNER3_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER3_HASHED_PASSWORD_ENCODED),
    },
    [process.env.REACT_APP_PARTNER4_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER4_HASHED_PASSWORD_ENCODED),
    },
    [process.env.REACT_APP_PARTNER5_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER5_HASHED_PASSWORD_ENCODED),
    },
    [process.env.REACT_APP_PARTNER6_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER6_HASHED_PASSWORD_ENCODED),
    },
    [process.env.REACT_APP_PARTNER7_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER7_HASHED_PASSWORD_ENCODED),
    },
    [process.env.REACT_APP_PARTNER8_USERNAME]: {
      hashedPassword: atob(process.env.REACT_APP_PARTNER8_HASHED_PASSWORD_ENCODED),
    }
  };


  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    const partner = Object.entries(partnerCredentials).find(([partnerUsername, _]) => partnerUsername === username);
    if (!partner) {
      setError('Invalid username or password.');
      return;
    }
    try {
      const isMatch = await bcrypt.compare(password, partner[1].hashedPassword);
      if (isMatch) {
        const token = btoa(username + ':' + new Date().getTime());
        localStorage.setItem('token', token);
        localStorage.setItem('partnerId', partner[0]); // Store partner identifier
        onLogin(partner[0]); // Pass partner identifier to onLogin
        console.log(`Login successful for partner: ${partner[0]}`);
      } else {
        setError('Invalid username or password.');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    }
  }, [username, password, onLogin]);

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        <div className="form-group">
          <Label htmlFor="username">Username</Label>
          <Input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <Label htmlFor="password">Password</Label>
          <Input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <Button type="submit">Login</Button>
      </form>
    </div>
  );
};

export default Login;
